export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REGISTER = 'REGISTER'
export const GET_EVENTS = 'GET_EVENTS'
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT'
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
export const UPDATE_EVENT = 'UPDATE_EVENT'
